import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#D1CFC7] bg-[#EAE7E0]"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
      <div>
        <span className="font-serif-display text-xl text-[#1E352F]">
          Flathead Trail Systems
        </span>
        <p className="text-sm text-[#4A5D54] mt-1">
          Hand &amp; machine built trails — Kalispell, Montana
        </p>
        <p className="text-sm text-[#4A5D54] mt-1">Jonathan Oftedahl</p>
      </div>

      <div className="text-sm text-[#4A5D54] space-y-2">
        <a
          href="tel:+14064713203"
          data-testid="footer-phone"
          className="flex items-center gap-2 hover:text-[#2D4A3E]"
        >
          <Phone className="h-4 w-4 text-[#A95C42]" /> (406) 471-3203
        </a>
        <a
          href="mailto:Jonathan@flatheadtrailsystems.com"
          data-testid="footer-email"
          className="flex items-center gap-2 hover:text-[#2D4A3E]"
        >
          <Mail className="h-4 w-4 text-[#A95C42]" /> Jonathan@flatheadtrailsystems.com
        </a>
        <span className="flex items-start gap-2">
          <MapPin className="h-4 w-4 text-[#A95C42] mt-0.5" /> P.O. Box 8842, Kalispell, MT 59904
        </span>
      </div>

      <div className="md:text-right">
        <Link
          to="/quote"
          data-testid="footer-quote-link"
          className="inline-flex items-center gap-2 bg-[#2D4A3E] text-[#F8F7F4] px-6 py-3 rounded-sm font-medium hover:bg-[#1E352F] transition-colors duration-300"
        >
          Request a Quote →
        </Link>
      </div>
    </div>
  </footer>
);
